import React from 'react';
import linkedin from '../../images/linkedin.jpg';
import fb from '../../images/fb.png';
import github from '../../images/github.png';
import twitter from '../../images/twitter.png';

const ContactForm = () => {
    return (
        <div className="row mt-5">
            <div className="mx-auto col-md-6 formBg px-3 py-2 mt-5">
                <h3 className="textColor pt-2 text-center">Get in touch</h3>
                <p className="textColor text-center">If you want to get in touch, feel free to contact me. CONTACT FORM CURRENTLY DOWN. PLEASE CONTACT ME DIRECTLY BY EMAIL.</p>
                <form>
                    <div class="form-group ">
                        <input type="name" class="form-control" id="name" placeholder="Your Name"/>
                    </div>
                    <div class="form-group mt-3">
                        <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="E-mail"/>
                    </div>
                    <div class="form-group mt-3">
                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Type your message here"></textarea>
                    </div>
                    <div class="text-center form-group mt-3">
                        <button type="submit" class="btn btn-success btn-block">Send</button>
                    </div>
                </form>           
            </div>
            <div className="mx-auto col-md-6 textColor text-center mt-5">
                <h4>Other contact</h4>
                <h6 className="mt-3"> Email: <a href="mailto:rajon26@student.sust.edu">rajon26@student.sust.edu</a></h6>
                <h5 className="mt-2">On Social media</h5>
                <a className="textColor text-decoration-none  m-1" href="https://www.linkedin.com/in/rajon749/" target="_blank" rel="noreferrer"> <img src={linkedin} className="socialMedia" alt="linkedin"/>                    
                </a>                                
                <a className="textColor text-decoration-none" href="https://github.com/rajonahmed749" target="_blank" rel="noreferrer"> <img src={github} className="socialMedia" alt="github"/>                    
                </a>   
                <a className="textColor text-decoration-none m-1" href="https://twitter.com/Rajon749" target="_blank" rel="noreferrer"> <img src={twitter} className="socialMedia" alt="fb"/>                    
                </a>             
                <a className="textColor text-decoration-none" href="https://www.facebook.com/razon.hossain.338/" target="_blank" rel="noreferrer"> <img src={fb} className="socialMedia " alt="fb"/>                    
                </a>             
            </div>
        </div>
    );
};

export default ContactForm;